import * as React from "react";

const ChevronUp: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M12 10.0001L5.94149 15.9402C5.43708 16.4347 4.61614 16.3865 4.17316 15.8362V15.8362C3.79023 15.3606 3.82726 14.6728 4.25904 14.2411L12 6.5001L19.741 14.2411C20.1727 14.6728 20.2098 15.3606 19.8268 15.8362V15.8362C19.3839 16.3865 18.5629 16.4347 18.0585 15.9402L12 10.0001Z" fill="currentColor"/>
        </svg>
    );
};

export default React.memo(ChevronUp);
